export default __webpack_public_path__ + "static/media/CalendarIcon.105a81bc.svg";